import React from 'react';
import {
    Text,
    Div,
    RequestDeliveryDateNotificationDiv,
} from './Notifications.styled';
import Popup from 'src/common/refactoredComponents/popup/Popup';
import Button from 'src/common/refactoredComponents/button/Button';
import { ButtonStyles } from 'src/constants/buttonStyles';
import { useTranslation } from 'react-i18next';

const RequestDeliveryDateNotification = ({ onClose }) => {
    const { t } = useTranslation();
    return (
        <>
            <Popup landscapeMarginTop={'30px'}
                titleWidth={'245px'}
                title={t(
                    'scheduleSurgery.surgery.notifications.requestDeliveryDateNotGuarenteed'
                )}
                onClose={onClose}
                id={'surgery-notification-requestDeliveryDateNotGuarenteed-popup'}
            >
                <RequestDeliveryDateNotificationDiv
                    mobileHeight={'max-content'}
                    mobileWidth={'340px'}
                >
                    <Text webHeight={'155px'} height={'max-content'}>
                        {t(
                            'ConsignmentAdd.surgery.notifications.dateDoesnotReachShippingFeasibility'
                        )}
                    </Text>
                    <Div position={'block'}>
                        <Button
                            id={'surgery-notifications-requestdeliverydatanotification-okbutton'}
                            show={true}
                            width={'110px'}
                            height={'38px'}
                            variant={ButtonStyles?.primary}
                            // primary={true}
                            margin={'5px 0 5px 5px'}
                            fontSize={'13px'}
                            clicked={onClose}
                        >
                            {t(
                                'scheduleSurgery.surgery.notifications.AiblePlanPdfNotAvailable.okButton'
                            )}
                        </Button>
                    </Div>
                </RequestDeliveryDateNotificationDiv>
            </Popup>
        </>
    );
};

export default RequestDeliveryDateNotification;
